// Utility functions

import { ChroniclerItem } from "./models/models";


// Array functions, for map/reduce/sort/etc
export function max(a: number, b: number) {
    return Math.max(a, b)
}

export function min(a: number, b: number) {
    return Math.min(a, b)
}

export function sum(a: number, b: number) {
    return a + b;
}

export function ascending(a: number, b: number) {
    return a - b
}
export function descending(a: number, b: number) {
    return b - a
}

export function add(value: number) {
    return (a: number) => (a + value);
}
export function multiply(value: number) {
    return (a: number) => (a * value);
}

export function average(array: number[]) {
    return array.reduce(sum, 0) / array.length
}
export function cumSum(array: number[]) {
    const out: number[] = [];
    let current = 0;
    array.forEach(value => {
        current += value;
        out.push(current)
    })
    return out;
}

// Math
export function roundTo(val: number, precision: number) {
    const factor = Math.pow(10, precision)
    return Math.round(val * factor) / factor
}

const standardRoundFactor = 3;
export function standardRound(val: number) {
    return roundTo(val, standardRoundFactor);
}

export function starRound(val: number, usePrecise: boolean) {
    if (usePrecise) {
        return standardRound(val);
    }
    return Math.round(val * 2) / 2
}

// String stuff

export function capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.substr(1);
}


// Date functions
export function chroniclerItemCoversTime<T>(item: ChroniclerItem<T>, time: string) {

    const startDate = new Date(item.valid_from);
    const testDate = new Date(time);

    if (startDate.getTime() <= testDate.getTime()) {
        if (item.valid_to === null) {
            return true;
        }
        const endDate = new Date(item.valid_to);
        return testDate.getTime() < endDate.getTime();
    }

}
export function dateAdd(base: string, mils: number) {
    const baseTime = new Date(base).getTime();
    return new Date(baseTime + mils).toISOString();
}